module.exports = __webpack_public_path__ + "img/icon-checkmark.5ad184bd.svg";